/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { Documents } from '../../../components/common/Documents/Documents';
import { EventList } from '../../../components/NotaryRoom/EventList/EventList';
import { DeviceSetting } from '../../../components/common/DeviceSetting/DeviceSetting';
import { Users } from './desktop/Users/Users';
import { SigningRoomNavigationItem } from './SigningRoomNavigationItem';

export type SigningRoomNavigationItemData = Pick<SigningRoomNavigationItem.Props, 'id' | 'title' | 'contentComponent'>;

export enum SigningRoomNavigationItemIds {
  participants = 'participants',
  documents = 'documents',
  activityLog = 'activityLog',
  settings = 'settings',
  exit = 'exit',
}

export const notaryNavigationItems: SigningRoomNavigationItemData[] = [
  {
    id: SigningRoomNavigationItemIds.participants,
    title: 'Participants',
    contentComponent: ({
      startCall,
      startVideoRecording,
    }: {
      startCall: () => Promise<void>;
      startVideoRecording: () => Promise<void>;
    }) => <Users startCall={startCall} startVideoRecording={startVideoRecording} />,
  },
  {
    id: SigningRoomNavigationItemIds.documents,
    title: 'Documents',
    contentComponent: ({
      handleDocumentClick,
      handleEditDocumentClick,
      handleFinalizeDocumentClick,
    }: {
      handleDocumentClick: (documentId: string) => void;
      handleEditDocumentClick: (documentId: string) => void;
      handleFinalizeDocumentClick: (documentId: string) => void;
    }) => (
      <Documents
        handleDocumentClick={handleDocumentClick}
        handleEditDocumentClick={handleEditDocumentClick}
        handleFinalizeDocumentClick={handleFinalizeDocumentClick}
      />
    ),
  },
  {
    id: SigningRoomNavigationItemIds.activityLog,
    title: 'Activity',
    contentComponent: () => <EventList />,
  },
  {
    id: SigningRoomNavigationItemIds.settings,
    title: 'Settings',
    contentComponent: () => <DeviceSetting />,
  },
];

export const participantNavigationItems: SigningRoomNavigationItemData[] = [
  {
    id: SigningRoomNavigationItemIds.participants,
    title: 'Participants',
    contentComponent: () => <Users />,
  },
  {
    id: SigningRoomNavigationItemIds.documents,
    title: 'Documents',
    contentComponent: ({ handleDocumentClick }: { handleDocumentClick: (documentId: string) => void }) => (
      <Documents handleDocumentClick={handleDocumentClick} />
    ),
  },
  {
    id: SigningRoomNavigationItemIds.settings,
    title: 'Settings',
    contentComponent: () => <DeviceSetting />,
  },
];
